<script>
  import { onMount } from 'svelte';
  import { rolePrives } from '../../Api.svelte';
  import { rolesStore, isRoleEditing, selectedPriv } from '../../stores/stores.js';
  import Switch from "svelte-switch";

  function handleChange(e) {
    const { checked } = e.detail;
    checkedValue = checked;
  }

  let role_name = '';
  let _id = null;
  let roleEditing = false;
  let checkedValue = true;
  let keys = [];
  let selectedPrivArray = [];

  isRoleEditing.subscribe(value => {
    console.log("isRoleEditing güncellendi:", value);
    roleEditing = value;
  });

  selectedPriv.subscribe(privs => {
    selectedPrivArray = Array.from(privs);
  });

  async function submitForm() {
    if (roleEditing) {
      await updateRole();
    } else {
      await addRole();
    }
  }

  async function addRole() {
    const result = await roleAdd(role_name, selectedPrivArray);
    if (result) {
      rolesStore.set(result);
      resetForm();
    } else {
      console.error('Kullanıcı ekleme başarısız.');
    }
  }

  async function updateRole() {
    const result = await roleUpdate(_id, role_name, checkedValue, selectedPrivArray);
    if (result) {
      rolesStore.set(result);
      isRoleEditing.set(false); // Düzenleme modu kapatılır
      resetForm();
    } else {
      console.error('Kullanıcı güncelleme başarısız.');
    }
  }

  function resetForm() {
    _id = null;
    role_name = '';
    selectedPriv.update(() => new Set());
  }

  onMount(async () => {
    keys = await rolePrives();
    console.log(keys);
  });

  function togglePrivSelection(key) {
    selectedPriv.update(privs => {
      if (privs.has(key)) {
        privs.delete(key);
      } else {
        privs.add(key);
      }
      return new Set(privs);
    });
  }
</script>

<div class="filter blur relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
  <div class="rounded-t bg-white mb-0 px-6 py-4">
    <div class="text-center flex justify-between">
      <h6 class="text-blueGray-700 text-xl font-bold">Role Bilgileri</h6>
      <button class="{roleEditing ? 'bg-lightBlue-400' : 'bg-red-400'} text-white active:{roleEditing ? 'bg-lightBlue-500' : 'bg-red-500'} font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click="{submitForm}">
        {roleEditing ? 'Düzenle' : 'Kaydet'}
      </button>
    </div>
  </div>

  <div class="flex-auto px-4 lg:px-10 py-8 pt-0">
    <form on:submit|preventDefault="{submitForm}">
      <div class="flex mt-4 flex-wrap">
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Yetkiler
            </div>
            <div class="flex flex-wrap">
              {#each keys as key (key)}
                {#if !selectedPrivArray.includes(key)}
                  <button
                    type="button"
                    class="border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-white text-blueGray-600"
                    on:click={() => togglePrivSelection(key)}>
                    {key}
                  </button>
                {/if}
              {/each}
            </div>
          </div>
        </div>
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <div class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
              Seçilen Yetkiler
            </div>
            <div class="flex flex-wrap">
              {#each selectedPrivArray as key (key)}
                <button
                  type="button"
                  class="border-0 px-3 py-2 m-1 rounded text-sm shadow focus:outline-none ease-linear transition-all duration-150 bg-emerald-500 text-white"
                  on:click={() => togglePrivSelection(key)}>
                  {key}
                </button>
              {/each}
            </div>
          </div>
        </div>
        <!-- Role Adı Alanı -->
        <div class="w-full lg:w-6/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="role_name">
              Role Adı
            </label>
            <input id="role_name" type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" bind:value="{role_name}" />
          </div>
        </div>
        
        <!-- Aktif/pasif -->
        {#if roleEditing}
        <div class="w-full lg:w-6/12 px-4 place-content-center">
          <div class="place-items-center">
            <span>Aktif Pasif Durumu</span>
            <Switch on:change={handleChange} checked={checkedValue} />
            Seçiminiz: {checkedValue ? "Aktif" : "Pasif"}
          </div>
        </div>
        {/if}
        <br/>
        <br/>
        <!-- Roller -->

      </div>
    </form>
  </div>
</div>
